import * as React from 'react';
import { useState } from 'react';
import * as navigation from 'app/area/shared/navigation';
import { ButtonPrimary } from 'ui';

import styles from './open-case.scss';

export interface OpenCaseProps {
  textCaseNo: string;
  textOpenCase: string;
  expandInputField?: boolean;
}

export const OpenCaseNumber = ({textCaseNo, textOpenCase, expandInputField}:OpenCaseProps) => {
  const [ caseNumber, setCaseNumber ] = useState('');

  const isInteger = caseNumber.match(/^\d+$/) && caseNumber.length < 17 && Number(caseNumber) <= Number.MAX_SAFE_INTEGER;

  function onChangeValue(event: React.ChangeEvent<HTMLInputElement>) {
    event.preventDefault();
    if (event && event.target) {
      setCaseNumber(event.target.value);
    }
  }

  function onOpenCase(event: React.FormEvent) {
    event.preventDefault();
    if (!!Number(caseNumber) && isInteger) {
      navigation.toCaseView(Number(caseNumber));
    }
  }

  return (
    <div className={`input-wrapper ${styles.inputSection}`}>
      <form onSubmit={onOpenCase} id="openCase">
        <input
          id="caseNumber"
          name="caseNumber"
          className={`form-control ${styles.inputElement} ${expandInputField ? styles.expand : ''}`}
          type="number"
          placeholder={textCaseNo}
          value={caseNumber}
          onChange={onChangeValue}
        />
        <ButtonPrimary
          onClick={onOpenCase}
          id="open_case"
          disabled={!isInteger || !Number(caseNumber)}
          className={`btn btn-call-to-action ${styles.btnOpenCase}`}
        >
          {textOpenCase}
        </ButtonPrimary>
      </form>
    </div>
  );
};
